<template>
  <v-col
    v-if="!hide"
    :key="subcategory.id"
    :class="loading && 'v-skeleton-loader v-skeleton-loader--is-loading badge-loading'"
    class="theme--light sub-category-badge"
    @click="handleClick"
  >
    <div
      :class="loading ? ' grey lighten-3 v-skeleton-loader__bone' : $getScoreColor(combinedValue, scale)"
      class="pt-2 pb-2 pl-2 pl-sm-4 badge-bg font-weight-bold white--text rounded"
    >
      <div class="badge-text">
        {{ subcategory.engineName === 'KULTTUURI' ? $t('reports.culture_leadership') : subcategory.nameText }}
        <br/>
        <span class="combined-value">{{ combinedValue === -1 ? 0 : combinedValue }}%</span>
      </div>
    </div>
  </v-col>
</template>

<script>
import {sum} from 'mathjs';

export default {
  name: 'ReportSubCategoryBadge',
  props: {
    name: {
      type: String,
      required: false,
    },
    category: {
      type: String,
      required: false,
    },
    surveys: {
      type: Array,
      required: false,
    },
    subcategory: {
      type: Object,
      required: false,
    },
    scale: {
      type: Array,
      default: () => [40, 60],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit('on-click', this.name);
    },
  },
  computed: {
    hide() {
      return this.subcategory?.engineName === 'KULTTUURI' && !this.managementSurvey;
    },
    personnelSurvey() {
      return this.surveys?.find(s => s.type === 'PERSONNEL');
    },
    managementSurvey() {
      return this.surveys?.find(s => s.type === 'MANAGEMENT');
    },
    personnelValue() {
      if (!this.personnelSurvey) return -1;
      let value;
      value = this.personnelSurvey?.calculation?.engineResponse?.lta?.[this.category]?.avg?.find(avg => avg.name === this.name)?.value;
      if (isNaN(value)) return -1;
      return parseFloat(parseFloat(value).toFixed(0));
    },
    managementValue() {
      if (!this.managementSurvey) return -1;
      let value;
      if (this.subcategory.engineName === 'KULTTUURI') {
        const values = this.managementSurvey?.calculation?.engineResponse?.oja?.['culture_leadership']?.avg?.map(c => c.value) || [];
        value = sum(values) / values.length;
      } else {
        value = this.managementSurvey?.calculation?.engineResponse?.oja?.[this.category]?.avg?.find(avg => avg.name === this.name)?.value;
      }
      if (isNaN(value)) return -1;
      return parseFloat(parseFloat(value).toFixed(0));
    },
    combinedValue() {
      if (this.managementValue === -1) return this.personnelValue;
      if (this.personnelValue === -1) return this.managementValue;
      return parseFloat(parseFloat((this.managementValue + this.personnelValue) / 2).toFixed(0));
    },
  },
};
</script>

<style lang="scss" scoped>
.badge-bg {
  transition: background-color 0.3s ease-in-out;
}

.badge-text {
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}

.badge-loading {
  .badge-bg {
    transition: background-color 0.3s ease-in-out;
  }

  .badge-text {
    opacity: 0;
  }
}

.sub-category-badge {
  font-size: 10px;
  cursor: pointer;
  line-height: 16px;
  transition: all 0.3s ease-in-out;
}

.combined-value {
  font-size: 18px;
}

@media screen and (min-width: 600px) {
  .sub-category-badge {
    font-size: 14px;
    line-height: 28px;
  }

  .combined-value {
    font-size: 42px;
  }
}
</style>
